module.exports = __webpack_public_path__ + "static/media/ico-youtube.a004e6a6.svg";